var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordVoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 95,
    viewBox: "0 0 110 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 54.9167C51.1116 54.9167 59.9166 46.1116 59.9166 35.25C59.9166 24.3884 51.1116 15.5833 40.25 15.5833C29.3884 15.5833 20.5833 24.3884 20.5833 35.25C20.5833 46.1116 29.3884 54.9167 40.25 54.9167Z",
    fill: "url(#paint0_linear_2812_5329)",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.25 64.75C27.1225 64.75 0.916626 71.3383 0.916626 84.4167V94.25H79.5833V84.4167C79.5833 71.3383 53.3775 64.75 40.25 64.75ZM78.4033 17.3533L70.1433 25.6625C74.2733 31.4642 74.2733 38.9867 70.1433 44.7883L78.4033 53.0975C88.335 43.1658 88.335 28.17 78.4033 17.3533ZM94.6775 0.833334L86.6633 8.8475C100.282 23.6958 100.282 46.0175 86.6633 61.6525L94.6775 69.6667C113.852 50.5408 113.902 20.7458 94.6775 0.833334Z",
    fill: "url(#paint1_linear_2812_5329)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2812_5329",
    x1: 0.916626,
    y1: 0.833334,
    x2: 93.3391,
    y2: 107.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#45A8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#A647E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2812_5329",
    x1: 0.916626,
    y1: 0.833334,
    x2: 93.3391,
    y2: 107.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.223958,
    stopColor: "#45A8E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#A647E6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordVoice);
export default __webpack_public_path__ + "static/media/record-voice.0a482f156ef3548703c84ae05c0854e8.svg";
export { ForwardRef as ReactComponent };